import { store } from 'store/index';

const tiposDeRedondeos = {
  CONVENCIONAL: 1,
  SIEMPRE_A_PESO_SUPERIOR: 2,
  SIEMPRE_A_PESO_INFERIOR: 3,
};
const truncateNumber = (val) => parseFloat(val.toFixed(2));
/**
 * @param {number} _val
 * @returns number
 */
const round = (_val) => {
  if (!_val) return null;
  const val = parseFloat(_val);
  if (Number.isNaN(val)) return null;
  const {
    utilizar_redondeo,
    tipo_de_redondeo = tiposDeRedondeos.CONVENCIONAL,
  } = store.getState()?.auth?.entidad;
  if (utilizar_redondeo) {
    if (tipo_de_redondeo === tiposDeRedondeos.CONVENCIONAL) {
      const decimales = val - Math.floor(val);
      if (decimales <= 0.5) {
        return truncateNumber(Math.floor(val));
      }
      return truncateNumber(Math.ceil(val));
    }
    if (tipo_de_redondeo === tiposDeRedondeos.SIEMPRE_A_PESO_SUPERIOR) {
      return truncateNumber(Math.ceil(val));
    }
    if (tipo_de_redondeo === tiposDeRedondeos.SIEMPRE_A_PESO_INFERIOR) {
      return truncateNumber(Math.floor(val));
    }
  }
  return truncateNumber(val);
};

export default round;
